import { AlertTriangle, CheckCircle2, Info, XCircle } from "lucide-react"

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { useToast } from "@/components/ui/use-toast"
import { cn } from "@/lib/utils"

const ICONS = {
  default: Info,
  success: CheckCircle2,
  destructive: XCircle,
  warning: AlertTriangle,
} as const

const ICON_TONE = {
  default: "text-brand",
  success: "text-success",
  destructive: "text-destructive",
  warning: "text-warning",
} as const

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, variant, ...props }) => {
        const key = (variant ?? "default") as keyof typeof ICONS
        const Icon = ICONS[key] ?? Info
        return (
          <Toast key={id} variant={variant} {...props}>
            <Icon className={cn("mt-px h-4 w-4 shrink-0", ICON_TONE[key])} />
            <div className="grid min-w-0 flex-1 gap-0.5">
              {title ? <ToastTitle>{title}</ToastTitle> : null}
              {description ? <ToastDescription>{description}</ToastDescription> : null}
              {action ? <div className="pt-1.5">{action}</div> : null}
            </div>
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
